module.exports = __webpack_public_path__ + "img/planCard.841da6bf.png";